import script from "./CollectivitesSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesSidebar.vue?vue&type=style&index=0&id=1d66e33c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d66e33c"]])

export default __exports__